import React from "react";
import ServiceAsideItem from "./ServiceAsideItem";
import ServiceCard from "./ServiceCard";
import ServiceFeature from "./ServiceFeature";
import ServiceSectionHead from "./ServiceSectionHead";
import mapServiceItem from "./mapServiceItem";

export default function ServiceSection({ section }) {
    const layout = section.layout || "cards";

    return (
        <section className={`service-detail-section ${section.tone ? `is-${section.tone}` : ""} ${section.variant ? `service-section-${section.variant}` : ""}`}>
            <div className="service-detail-inner">
                <ServiceSectionHead section={section} />

                {section.paragraphs?.length ? (
                    <div className="service-split">
                        <div className="service-copy-block">
                            {section.paragraphs.map((paragraph) => (
                                <p key={paragraph}>{paragraph}</p>
                            ))}
                        </div>
                        {section.aside ? (
                            <aside className="service-aside">
                                <h3>{section.aside.title}</h3>
                                {section.aside.items.map((item, index) => (
                                    <ServiceAsideItem key={`${section.aside.title}-${index}`} item={item} />
                                ))}
                            </aside>
                        ) : null}
                    </div>
                ) : null}

                {section.feature ? <ServiceFeature feature={section.feature} /> : null}

                {section.groups?.length ? (
                    <div className="service-group-stack">
                        {section.groups.map((group) => (
                            <div className="service-group" key={group.title}>
                                <h3 className="service-group-title">{group.title}</h3>
                                <div className={`service-card-row service-card-row-${group.layout || layout}`}>
                                    {group.items.map((item) => {
                                        const card = mapServiceItem(item);
                                        return <ServiceCard key={`${card.marker}-${card.title}`} item={card} layout={group.layout || layout} />;
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}

                {section.items?.length ? (
                    <div className={`service-card-row service-card-row-${layout}`}>
                        {section.items.map((item) => {
                            const card = mapServiceItem(item);
                            return <ServiceCard key={`${card.marker}-${card.title}`} item={card} layout={layout} />;
                        })}
                    </div>
                ) : null}

                {section.chipsTitle ? <h3 className="service-chips-title">{section.chipsTitle}</h3> : null}

                {section.chips?.length ? (
                    <div className="service-chip-row">
                        {section.chips.map((chip) => (
                            <span key={chip}>{chip}</span>
                        ))}
                    </div>
                ) : null}
            </div>
        </section>
    );
}
